export default __webpack_public_path__ + "static/media/8.df20b4d5.png";